import { Container as MuiContainer, ContainerProps } from '@mildang/mui';
import type { Theme } from '@mildang/mui';
import { css as emotionCSS } from '@emotion/react';

const fullFluidStyle = (theme: Theme) => emotionCSS`
  ${theme.breakpoints.up('xs')} {
    max-width: ${400 + Number(16) * 2}px;
  }
  ${theme.breakpoints.up('sm')} {
    max-width: ${720 + Number(24) * 2}px;
  }
  ${theme.breakpoints.up('md')} {
    max-width: ${1140 + Number(24) * 2}px;
  }
  ${theme.breakpoints.up('lg')} {
    max-width: ${1140 + Number(24) * 2}px;
  }
`;

export interface IContainerProps extends ContainerProps {
  fullFluid?: boolean;
}

const Container = (props: IContainerProps) => {
  const { fullFluid = false, ...other } = props;
  return (
    <MuiContainer
      css={(theme: any) => {
        if (fullFluid) {
          return fullFluidStyle(theme);
        }
        return undefined;
      }}
      {...other}
    />
  );
};

export default Container;
